import React, { Component, Fragment } from "react";
import MetaTags from "react-meta-tags";
import Content from "../sections/error/Content";

const pagelocation = "Page non trouvée";

class Error extends Component {
	render() {
		return (
			<Fragment>
				<MetaTags>
					<title>{pagelocation}</title>
					<meta name="description" content="#" />
				</MetaTags>
				<div
					style={{
						backgroundImage:
							"url(" + process.env.PUBLIC_URL + "/assets/img/bg/pattern.jpg)",
					}}
				>
					{/* <Header /> */}
					<Content />
					{/* <Footer footer={{ style: "ct-footer footer-dark", logo: "assets/img/logo-light.png" }} /> */}
				</div>
			</Fragment>
		);
	}
}

export default Error;
